import styled from "styled-components"

import { ReactComponent as ExclamationTriangleIcon } from "assets/svg/exclamation-triangle.svg"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;
  padding: 48px 16px;
  min-height: 50vh;
`

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background-color: #f1f5f9;
  border-radius: 50%;

  svg {
    width: 32px;
    height: 32px;
    color: #334155;
  }
`

const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
  text-align: center;
`

const Title = styled.h3`
  font-weight: 400;
  font-size: 20px;
  color: #334155;
`

const Description = styled.p`
  font-size: 16px;
  color: #64748b;
  max-width: 400px;
  font-weight: 300;
  line-height: 26px;
`

interface Props {
  priority: string
}

export const IntelligenceReportsEmptyState = ({ priority }: Props) => {
  const isHigh = priority.toLowerCase() === "high"

  return (
    <Container>
      <IconWrapper>
        <ExclamationTriangleIcon />
      </IconWrapper>
      <Body>
        <Title>No {priority.toLowerCase()} priority reports this week</Title>
        {isHigh && (
          <Description>
            All thermostats in this period are operating within normal parameters. High priority issues will appear here
            when detected.
          </Description>
        )}
      </Body>
    </Container>
  )
}
